import { useState } from "react";
import { DynamicDropdown } from "src/Components";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
import {
  IFreezedCoveredCallSearchParams,
  ISendManualCMDDTO,
} from "src/Interfaces/collateral";
import {
  getDecreaseCoveredCallTable,
  getFreezedCoveredCallTable,
  getOptimizedAdaptionTable,
} from "src/Requests/collateral";
import { getBaseInstruments } from "src/Requests/iMEMarketWatch";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { FreezeCoveredCallTableAdditional } from "./TableAdditionals/CoveredCallTableAdditional";

const CoveredCall = () => {
  const [searchParams, setSearchParams] = useState(
    {} as IFreezedCoveredCallSearchParams,
  );
  const [selectedRowInfo, setSelectedRowInfo] = useState(
    {} as ISendManualCMDDTO,
  );

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-5">
      <div className="flex flex-row justify-start items-center gap-3 mx-auto">
        <div className="w-64">
          <UsersDropdown
            label="اکانت"
            name="accountId"
            value={searchParams.accountId}
            onChange={changeHandler}
            extraLabel
          />
        </div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "instrumentId",
              placeholder: "نماد پایه",
              extraLabel: true,
            }}
            onChange={changeHandler}
            getData={() => getBaseInstruments()}
            value={searchParams.instrumentId}
          />
        </div>
      </div>

      <TableTemplate
        refreshTableTime={5000}
        pagesize={200}
        withSort
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            withSelect
            sortingType={sortingType}
            setSortingType={setSortingType}
            activeRowId={selectedRowInfo.id}
            AdditionalBody={FreezeCoveredCallTableAdditional}
            onTableRowClick={(row) =>
              setSelectedRowInfo({
                baseinstrumentid: row.baseinstrumentid,
                userid: row.userid,
                id: row.id,
              })
            }
            tableBoxClassName="!max-h-[500px]"
          />
        )}
        getDataTable={getFreezedCoveredCallTable}
        searchParameters={searchParams}
      />

      {selectedRowInfo && selectedRowInfo.baseinstrumentid ? (
        <TableTemplate
          TableUI={({ reports, onAction }) => (
            <CommonTableUI reports={reports} onAction={onAction} />
          )}
          getDataTable={getDecreaseCoveredCallTable}
          searchParameters={selectedRowInfo}
        />
      ) : (
        <></>
      )}
      {selectedRowInfo && selectedRowInfo.baseinstrumentid ? (
        <TableTemplate
          TableUI={({ reports, onAction }) => (
            <CommonTableUI reports={reports} onAction={onAction} />
          )}
          getDataTable={getOptimizedAdaptionTable}
          searchParameters={selectedRowInfo}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CoveredCall;
